"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreEligibilityStepToJSON = exports.PreEligibilityStepFromJSONTyped = exports.PreEligibilityStepFromJSON = void 0;
const runtime_1 = require("../runtime");
function PreEligibilityStepFromJSON(json) {
    return PreEligibilityStepFromJSONTyped(json, false);
}
exports.PreEligibilityStepFromJSON = PreEligibilityStepFromJSON;
function PreEligibilityStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'eligibleForMembership': !runtime_1.exists(json, 'eligibleForMembership') ? undefined : json['eligibleForMembership'],
    };
}
exports.PreEligibilityStepFromJSONTyped = PreEligibilityStepFromJSONTyped;
function PreEligibilityStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'eligibleForMembership': value.eligibleForMembership,
    };
}
exports.PreEligibilityStepToJSON = PreEligibilityStepToJSON;
//# sourceMappingURL=PreEligibilityStep.js.map